import { Component, Host, h, Prop, Method, Watch, Event, Element } from '@stencil/core';
/**
 * @slot  - Children elements of collapse.
 */
export class Collapse {
  constructor() {
    this.eventTrigger = null;
    /**
     * Defines if the collapse component is visible.
     */
    this.opened = false;
  }
  openedWatcher(newValue, oldValue) {
    if (oldValue !== newValue) {
      if (newValue) {
        this.syCollapseDidOpen.emit();
      }
      else {
        this.syCollapseDidClose.emit();
      }
    }
  }
  /**
   * Open the collapsed component.
   */
  async open() {
    this.opened = true;
  }
  /**
   * Close the collapsed component.
   */
  async close() {
    this.opened = false;
  }
  /**
   * Toggle the state of collapsed component.
   */
  async toggle() {
    this.opened = !this.opened;
  }
  componentDidLoad() {
    const rootNode = this.el.getRootNode();
    const trigger = rootNode.querySelectorAll(this.triggerBy);
    if (trigger) {
      this.eventTrigger = trigger;
      this.eventTrigger.forEach(el => {
        el.addEventListener('click', this.toggle.bind(this));
      });
    }
  }
  disconnectedCallback() {
    if (this.el.isConnected)
      return;
    if (this.eventTrigger) {
      this.eventTrigger.forEach(el => {
        el.removeEventListener('click', this.toggle.bind(this));
      });
    }
  }
  render() {
    return (h(Host, Object.assign({}, (this.opened ? { opened: true } : null)),
      h("slot", null)));
  }
  static get is() { return "sy-collapse"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "opened": {
      "type": "boolean",
      "mutable": true,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines if the collapse component is visible."
      },
      "attribute": "opened",
      "reflect": true,
      "defaultValue": "false"
    },
    "triggerBy": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": true,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Set the css selector that will be listened to control the collapse component state."
      },
      "attribute": "trigger-by",
      "reflect": false
    }
  }; }
  static get events() { return [{
      "method": "syCollapseDidOpen",
      "name": "syCollapseDidOpen",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Fired when collapse is opened."
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }, {
      "method": "syCollapseDidClose",
      "name": "syCollapseDidClose",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Fired when collapse is closed."
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }]; }
  static get methods() { return {
    "open": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Open the collapsed component.",
        "tags": []
      }
    },
    "close": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Close the collapsed component.",
        "tags": []
      }
    },
    "toggle": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Toggle the state of collapsed component.",
        "tags": []
      }
    }
  }; }
  static get elementRef() { return "el"; }
  static get watchers() { return [{
      "propName": "opened",
      "methodName": "openedWatcher"
    }]; }
}
